/**
 * Adding fingerprint header to the request
 * We are using userId as userEmail or, when not logged, we user segment guest_id
 */
export function getUserIdAndFingerPrintHeader<T extends { user?: { email?: string } }>(fingerprint: string, data?: T) {
  const userId = data?.user?.email || localStorage?.getItem('guest_id');
  return {
    'X-Requested-From': fingerprint,
    'X-Requested-UserId': userId,
    'x-offers-source': 'ari',
  };
}
